/*! HorizontalSmoothScrollLayout | MIT License | https://github.com/codrops/HorizontalSmoothScrollLayout */

import { gsap } from "gsap";
import { lerp, getMousePos } from "./utils";

// Track the mouse position
let mouse = { x: 0, y: 0 };
window.addEventListener("mousemove", (ev) => (mouse = getMousePos(ev)));

export default class Cursor {
  DOM: { cursorEl: HTMLElement | null; cursorOutlineEl: HTMLElement | null };
  bounds: DOMRect;
  renderedStyles: {
    tx: { previous: number; current: number; amt: number };
    ty: { previous: number; current: number; amt: number };
    scale: { previous: number; current: number; amt: number };
    opacity: { previous: number; current: number; amt: number };
  };
  onMouseMoveEv: () => void;
  constructor(
    cursorEl: HTMLElement | null,
    cursorOutlineEl: HTMLElement | null
  ) {
    this.DOM = { cursorEl: cursorEl, cursorOutlineEl: cursorOutlineEl };

    if (this.DOM.cursorEl) {
      this.DOM.cursorEl.style.opacity = "0";

      this.bounds = this.DOM.cursorEl.getBoundingClientRect();
    }

    this.renderedStyles = {
      tx: { previous: 0, current: 0, amt: 0.2 },
      ty: { previous: 0, current: 0, amt: 0.2 },
      scale: { previous: 0, current: 0, amt: 0.15 },
      opacity: { previous: 0, current: 0, amt: 0.1 },
    };

    this.onMouseMoveEv = () => {
      this.renderedStyles.tx.previous = this.renderedStyles.tx.current =
        mouse.x - this.bounds.width / 2;
      this.renderedStyles.ty.previous = this.renderedStyles.ty.previous =
        mouse.y - this.bounds.height / 2;
      gsap.to(this.DOM.cursorEl, {
        duration: 0.9,
        ease: "Power3.easeOut",
        opacity: 1,
      });
      requestAnimationFrame(() => this.render());
      window.removeEventListener("mousemove", this.onMouseMoveEv);
    };
    window.addEventListener("mousemove", this.onMouseMoveEv);
  }
  enter() {
    this.renderedStyles["scale"].current = 1;
    this.renderedStyles["opacity"].current = 1;
  }
  leave() {
    this.renderedStyles["scale"].current = 0;
    this.renderedStyles["opacity"].current = 0;
  }
  render() {
    this.renderedStyles["tx"].current = mouse.x - this.bounds.width / 2;
    this.renderedStyles["ty"].current = mouse.y - this.bounds.height / 2;

    for (const key in this.renderedStyles) {
      this.renderedStyles[key].previous = lerp(
        this.renderedStyles[key].previous,
        this.renderedStyles[key].current,
        this.renderedStyles[key].amt
      );
    }

    if (this.DOM.cursorEl && this.DOM.cursorOutlineEl) {
      this.DOM.cursorEl.style.transform = `translateX(${this.renderedStyles["tx"].previous}px) translateY(${this.renderedStyles["ty"].previous}px)`;
      this.DOM.cursorOutlineEl.style.transform = `scale(${this.renderedStyles["scale"].previous}) translate(25%, 25%)`;
      this.DOM.cursorEl.style.opacity = `${this.renderedStyles["opacity"].previous}`;
    }

    requestAnimationFrame(() => this.render());
  }
}
